<template>
  <div class="ruKuZuoyeWarp">
    <div class="ruKuZuoyeWarp-body">
      <!-- 查询条件 -->
      <div ref="searchBox" class="formBox margbot">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="110px" size="mini">
          <div class="formItemBox">
          <el-form-item label="车号:">
            <el-input v-model.trim="formData.instockPlateNumber" placeholder="请输入车号" size="mini"
              ></el-input>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:">
            <div style="display: flex;">
            <el-date-picker v-model="formData.createTimeStart" size="mini" type="date" placeholder="选择创建日期"
              value-format="yyyy-MM-dd"></el-date-picker>
            -
            <el-date-picker v-model="formData.createTimeEnd" size="mini" placeholder="选择创建日期" type="date"
              value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="司机:">
            <el-input class="ipt" v-model.trim="formData.driverName" placeholder="请输入司机名" size="mini"
             ></el-input>
          </el-form-item>
          <el-form-item label="入库单号:">
            <el-input class="ipt" v-model.trim="formData.instockNo" placeholder="请输入入库单号" size="mini"
             ></el-input>
          </el-form-item>
          <el-form-item label="到货方式:">
            <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP001B001" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP001B002" v-if="btnFlg[1]">重置
            </el-button>
            <el-button type="primary" size="mini" @click="xinzeng" btnCode="00cP001B003" v-if="btnFlg[2]">新增</el-button>
            <el-button type="primary" size="mini" @click="xiugai" btnCode="00cP001B004" v-if="btnFlg[3]">修改</el-button>
            <el-button type="primary" size="mini" @click="shanchu" btnCode="00cP001B005" v-if="btnFlg[4]">删除</el-button>
            <el-button type="primary" size="mini" @click="dayin" btnCode="00cP001B006" v-if="btnFlg[5]">打印</el-button>
            <el-button type="primary" size="mini" @click="daochu" btnCode="00cP001B007" v-if="btnFlg[6]">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div :style="{ height: h }">
        <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"  class="tableComent"
          style="width: 100%" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row
          @row-click="dianjixuanzhong">
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="lookImg(scope.row)" size="mini">查看单据</el-button>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center" width="220">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" align="center"
            width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
            width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机姓名" align="center" width="100">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center" width="150">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="110">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车船号" align="center" width="130">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="shipForecastNo" label="预报编号" align="center" width="200">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="180"
            :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="ext1" label="备注" align="center" width="150">
          </el-table-column>
        </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
          :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
        </el-pagination>
      </div>
      <div class="market_out">
        <div class="detailsTitle">
          <h4>货物详情</h4>
        </div>
        <!--货物详情-->
        <div>
          <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
            <el-button type="primary" size="mini" @click="xc" btnCode="00cP001B008" v-if="btnFlg[7]">确认入库</el-button>
            <el-button type="primary" size="mini" @click="weighClick" btnCode="00cP001B009" v-if="btnFlg[8]">过磅
            </el-button>
            <el-button type="primary" size="mini" @click="heBangClick" btnCode="00cP001B00A"
              v-if='heBangDisabled && btnFlg[9]'>合磅</el-button>
            <span>
              总吨数:
              <span style="color: red">{{ totalAllWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ totalNumber }}</span> &nbsp;件
            </span>
          </div>
          <!--详情表格-->
          <div class="ruKuZuoyeWarp-body-detailsTab">
            <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
              <el-table height="100%" size="mini" ref="tabref" :data="detailsData" style="width: 100%"
                :header-cell-style="{
                  background: '#F5F5F5',
                  color: 'black',
                }" highlight-current-row @row-click="dianjixuanzhongXQ" border center bordersize="mini">
                <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                <el-table-column align="center" label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="text" @click="guoBangClick(scope.row)" size="mini">过磅记录</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
                <el-table-column prop="steelMillName" label="产地" align="center" width="120"></el-table-column>
                <el-table-column prop="specification" label="规格" align="center" width="150"></el-table-column>
                <el-table-column prop="model" label="材质" align="center" width="150"></el-table-column>
                <el-table-column prop="singletonWeight" label="单件理重（吨）" align="center" width="120"></el-table-column>
                <el-table-column prop="number" label="件数" align="center" width="90"></el-table-column>
                <el-table-column prop="allWeight" label="总重量（吨）" align="center" width="120"></el-table-column>
                <el-table-column prop="weight" label="理重(吨)" align="center" width="100"></el-table-column>
                <el-table-column prop="factoryWeight" label="出厂过磅净重（吨）" align="center" width="160"></el-table-column>
                <el-table-column prop="weighingWeight" label="过磅净重（吨）" align="center" width="150"></el-table-column>
                <el-table-column prop="grossWeight" label="毛重(吨)" align="center" width="100"></el-table-column>
                <el-table-column prop="tareWeight" label="皮重(吨)" align="center" width="100"></el-table-column>
                <el-table-column prop="wareHouseName" label="仓位" align="center" width="100"></el-table-column>
              </el-table>
            </div>
            <!--分页-->
            <div class="pags" style="text-align: right">
              <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo"
                :page-size="pageInfoXQ.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
                layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增入库计划 -->
    <ruku-plan-dialog v-if="xzVisible" :xzVisible.sync="xzVisible" :title="xzTitle" :xztableData="xztableData"
      :xiugaiObj="xiugaiObj" :RKData.sync='RKData'></ruku-plan-dialog>
    <!-- 卸车确认 -->
    <xie-che-dialog v-if="xcVisible" :xcVisible.sync='xcVisible' :instockId="instockId" :chepai='chepai'
      :warehouseId='warehouseId'></xie-che-dialog>
    <!-- 查看单据 -->
    <dj-dialog v-if="CKDJVisible" :CKDJVisible.sync='CKDJVisible' :instockId="instockId"></dj-dialog>
    <!-- 过磅 -->
    <weigh-dialog v-if="weighVisible" :weighVisible.sync='weighVisible' :instockId="instockId" :chepai='chepai'>
    </weigh-dialog>
    <!-- 合磅 -->
    <heBang-dialog v-if="heBangVisible" :heBangVisible.sync='heBangVisible' :instockId="instockId" :chepai='chepai'>
    </heBang-dialog>
    <!-- 过磅记录 -->
    <gBJiLu-dialog v-if="guoBangVisible" :guoBangVisible.sync='guoBangVisible' :instockSummaryId="instockSummaryId">
    </gBJiLu-dialog>
  </div>
</template>

<script>
import {
  JfgetThreadExpList,
  zidianKuwei,
  getInstockSummaryList,
  JfgetThreadDetailExpWN,
  checkShipForecastActualNumber,
  removeInstockPlan // 删除
} from '@/api/wms-access'
import {
  getRelationCustomer,
  getUsersByTenantCode,
  zidian,
  getWeighingMethodList
} from '@/api/wms-stock'
import {
  dateTimeFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import RukuPlanDialog from './rukuPlanDialog.vue'
import XieCheDialog from './xieCheDialog.vue'
import weighDialog from './weighDialog.vue'
import djDialog from '../yycChuanYun/dialog/DJindex.vue'
import heBangDialog from './heBangDialog.vue'
import gBJiLuDialog from '../gBJiLuDialog.vue'

export default {
  components: {
    RukuPlanDialog,
    XieCheDialog,
    djDialog,
    weighDialog,
    heBangDialog,
    gBJiLuDialog
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      formData: {
        instockPlateNumber: '',
        primaryCustomerName: '',
        customerName: '',
        createTimeStart: '',
        createTimeEnd: '',
        driverName: '',
        customerTaxId: '',
        primaryCustomerTaxId: '',
        instockNo: '',
        arrivalMethod: ''
      },
      HwTypeData: [],
      totalXQ: 0,
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageInfoXQ: {
        pageSize: 20,
        pageNo: 1
      },
      total: 0,
      detailsData: [], // 详情数据
      RKData: [], //
      btnFlg: [],
      tableData: [],
      totalAllWeight: '',
      totalNumber: '',
      btnIdArr: [
        '00cP001B001',
        '00cP001B002',
        '00cP001B003',
        '00cP001B004',
        '00cP001B005',
        '00cP001B006',
        '00cP001B007',
        '00cP001B008',
        '00cP001B009',
        '00cP001B00A'
      ],
      detailsH: '200px',
      h: '500px',
      xuanzhongArr: null,
      xuanzhongArrXQ: null,
      xcLoading: false,
      inWeighingMethod: '',
      xzVisible: false,
      xzTitle: '新增入库计划',
      xztableData: [],
      xcVisible: false,
      xiugaiObj: {},
      xieCheTable: [],
      chepai: '',
      instockId: '',
      warehouseId: '',
      arrivalMethodData: [{
        value: '1',
        label: '火运'
      },
      {
        value: '2',
        label: '汽运'
      },
      {
        value: '3',
        label: '船运'
      }
      ],
      // 查看单据
      CKDJVisible: false,
      weighVisible: false,
      heBangVisible: false,
      guoBangVisible: false,
      instockSummaryId: '',
      heBangDisabled: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycRKPlan')
    this.getRelationCustomerS()
    this.chaxun()
    this.zidians()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 175 + 'px'
    this.detailsH = 0.4 * pH - h2 - 80 + 'px'
  },
  methods: {
    // 查看单据
    lookImg (row) {
      this.CKDJVisible = true
      this.instockId = row.instockId
    },
    // 总重量
    JfgetThreadDetailExpWNs () {
      JfgetThreadDetailExpWN({
        instockId: this.xuanzhongArr.instockId
      })
        .then(res => {
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    xc () {
      if (this.detailsData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
      } else if (this.xuanzhongArr.primaryCustomerName == '' && this.xuanzhongArr.customerName == '') {
        this.$message.error('请先完善信息')
      } else {
        checkShipForecastActualNumber({
          instockId: this.xuanzhongArr.instockId
        })
          .then(res => {
            const confirmText = ['实际入库货物件数累加大于预报件数', '是否确认入库？']
            const newDatas = []
            const h = this.$createElement
            for (const i in confirmText) {
              newDatas.push(h('p', null, confirmText[i]))
            }
            if (res == '弹') {
              this.$confirm('提示', {
                title: '提示',
                message: h('div', null, newDatas),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  this.xcVisible = true
                  this.chepai = this.xuanzhongArr.instockPlateNumber
                  this.instockId = this.xuanzhongArr.instockId
                  this.warehouseId = this.xuanzhongArr.warehouseId
                })
                .catch(() => {

                })
            } else {
              this.xcVisible = true
              this.chepai = this.xuanzhongArr.instockPlateNumber
              this.instockId = this.xuanzhongArr.instockId
              this.warehouseId = this.xuanzhongArr.warehouseId
            }
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    // 过磅
    weighClick () {
      if (this.detailsData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
      } else if (this.xuanzhongArr.primaryCustomerName == '' && this.xuanzhongArr.customerName == '') {
        this.$message.error('请先完善信息')
      } else {
        this.weighVisible = true
        this.instockId = this.xuanzhongArr.instockId
        this.chepai = this.xuanzhongArr.instockPlateNumber
      }
    },
    // 合磅
    heBangClick () {
      if (this.detailsData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
      } else if (this.xuanzhongArr.primaryCustomerName == '' && this.xuanzhongArr.customerName == '') {
        this.$message.error('请先完善信息')
      } else {
        // 货物信息有且只有毛重时才能点击合磅
        this.heBangVisible = true
        this.instockId = this.xuanzhongArr.instockId
        this.chepai = this.xuanzhongArr.instockPlateNumber
      }
    },
    // 点击过磅记录
    guoBangClick (row) {
      this.guoBangVisible = true
      this.instockSummaryId = row.instockSummaryId
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.JfgetThreadDetailExpLists()
    },
    xinzeng () {
      this.xzVisible = true
      this.xzTitle = '新增入库计划'
    },
    xiugai () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.xzVisible = true
      this.xzTitle = '修改入库计划'
      this.xiugaiObj = this.xuanzhongArr
      this.xztableData = this.detailsData
    },
    shanchu () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeInstockPlan(this.xuanzhongArr.instockId)
          .then(res => {
            DonMessage.success('删除成功')
            that.chaxun()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    chaxun () {
      JfgetThreadExpList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockPlateNumber: this.formData.instockPlateNumber,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        createTimeStart: this.formData.createTimeStart,
        createTimeEnd: this.formData.createTimeEnd,
        driverName: this.formData.driverName,
        instockStatus: 0,
        instockNo: this.formData.instockNo,
        arrivalMethod: this.formData.arrivalMethod
      })
        .then(res => {
          this.tableData = res.list
          if (res.list.length) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => {
              this.$refs.tabref1.setCurrentRow(res.list[0])
              console.log(this.$route.params, 'this.$route.params')
              if (this.$route.params.id) {
                this.instockId = res.list[0].instockId
                this.weighVisible = true
                this.chepai = this.$route.params.vehicleNo
              } else {
                this.weighVisible = false
              }
            })
            this.JfgetThreadDetailExpLists()
          } else {
            this.detailsData = []
            this.totalAllWeight = 0
            this.totalNumber = 0
            this.totalXQ = 0
          }
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhi () {
      this.formData.instockPlateNumber = ''
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.createTimeStart = ''
      this.formData.createTimeEnd = ''
      this.formData.productType = ''
      this.formData.driverName = ''
      this.formData.instockNo = ''
      this.formData.arrivalMethod = ''
      this.chaxun()
    },
    dayin () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({
        path: '/yycXieCheDan',
        query: {
          id: this.xuanzhongArr.instockId
        }
      })
    },

    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.JfgetThreadDetailExpLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.JfgetThreadDetailExpLists()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 货物详情
    JfgetThreadDetailExpLists () {
      getInstockSummaryList({
        instockId: this.xuanzhongArr.instockId,
        ...this.pageInfoXQ
      })
        .then(res => {
          this.detailsData = res.list
          this.totalXQ = res.total
          this.xuanzhongArrXQ = res.list[0]
          this.JfgetThreadDetailExpWNs()
          this.$nextTick(() => {
            this.$refs.tabref.setCurrentRow(res.list[0])
          })
          // 货物信息有且只有毛重时才能点击合磅
          // 有毛重且没有净重  可点合磅
          if (this.detailsData.length != 0) {
            let flagA = this.detailsData.every(item => !!item.grossWeight && !item.weighingWeight)
            if (flagA) {
              this.heBangDisabled = true
            } else {
              this.heBangDisabled = false
            }
          }
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    dianjixuanzhongXQ (row) {
      this.xuanzhongArrXQ = {}
      this.xuanzhongArrXQ = row
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({})
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.ckData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 现场人员
    getUsersByTenantCodes () {
      getUsersByTenantCode()
        .then(res => {
          this.ryData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型
    zidians () {
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          this.HwTypeData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 获取货物计重方式
    getWeighingMethodLists (productType) {
      getWeighingMethodList({
        productType
      })
        .then(res => {
          if (res.length > 0) this.inWeighingMethod = res[0].inWeighingMethod
          if (res[0].inWeighingMethod == 2) {
            this.xiecheRules.weighingWeight[0].required = true
            this.xiecheRules.weighingDate[0].required = true
          } else {
            this.xiecheRules.weighingWeight[0].required = false
            this.xiecheRules.weighingDate[0].required = false
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/instockThreadExp/exportMasterAndSummary', {
          ...this.formData,
          instockStatus: '0'
        },
        '入库计划'
      )
    }
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  .ruKuZuoyeWarp {
    width: 100%;
    position: relative;
  }
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

</style>
